import React from 'react'
import { NodeDndToc, WithParentId } from '../dnd_toc/types'
import { NodeIdMap } from '../version_mapping/utility'
import { INode } from 'shared/types/tree'

type TreeEditingData = {
  onItemDrop: (
    droppedItem: WithParentId<NodeDndToc>,
    nextItem: WithParentId<NodeDndToc>,
  ) => void
  idMaps: { [k: string]: NodeIdMap }
  trees: { [id: string]: INode }
  treesUpdated: (ids: string[] | INode) => unknown
  removeTree: (treeId: string) => void
}

const emptyValue = {
  onItemDrop: () => {},
  idMaps: {},
  trees: {},
  treesUpdated: () => {},
  removeTree: () => {},
}

export const TreeEditingContext =
  React.createContext<TreeEditingData>(emptyValue)
